import React, { useState, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule,
} from "devextreme-react/form";
import LoadIndicator from "devextreme-react/load-indicator";
import notify from "devextreme/ui/notify";
import { resetPassword } from "../../api/auth";
import "./ResetPasswordForm.scss";
import AUTH_API from "api/authApi";
import { usePost } from "@hooks/useAuthApi";
import { showNotification } from "utils/helpers";
import Loader from "@common-components/loader/Loader";

const notificationText =
  "We've sent a link to reset your password. Check your inbox.";

export default function ResetPasswordForm() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formData = useRef({ email: "" });
  const { mutate: forgotPassword } = usePost(
    "forgotPassword",
    AUTH_API.FORGOT_PASSWORD
  );

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      // navigate("/otp");
      setLoading(true);
      forgotPassword(formData.current, {
        onSuccess: (response) => {
          if (response.isSuccess) {
            navigate("/otp", { state: { email: formData.current.email } });
            showNotification(notificationText, "success");
          } else {
            showNotification(response.errors[0].errorMessageEn, "error");
          }
        },
        onError: (error) => {
          showNotification(error.message, "warning");
        },
        onSettled: () => {
          setLoading(false);
        },
      });
      // if (result.isOk) {
      //   navigate('/change-password/:recoveryCode');
      //   notify(notificationText, 'success', 2500);
      // } else {
      //   notify(result.message, 'error', 2000);
      // }
    },
    [navigate]
  );

  return (
    <>
      <form className={"reset-password-form"} onSubmit={onSubmit}>
        {/* <p className="text-xl mb-1">Forgot Password 🔒</p> */}
        <p className="text-xs">
          Please enter your registered email to receive the reset code.
        </p>
        <Form
          formData={formData.current}
          disabled={loading}
          labelMode="outside"
          labelLocation="top"
          showColonAfterLabel={false}
          className="mt-4"
        >
          <Item
            dataField={"email"}
            editorType={"dxTextBox"}
            editorOptions={emailEditorOptions}
            isRequired={true}
          >
            <RequiredRule message="Email is required" />
            <EmailRule message="Email is invalid" />
          </Item>
          <ButtonItem>
            <ButtonOptions
              elementAttr={submitButtonAttributes}
              width={"100%"}
              height={"40px"}
              type={"default"}
              useSubmitBehavior={true}
            >
              <span className="dx-button-text">
                {loading ? (
                  <Loader
  
                  />
                ) : (
                  "Send Reset Code"
                )}
              </span>
            </ButtonOptions>
          </ButtonItem>
          <Item>
            <div className={"login-link"}>
              <Link
                to={"/login"}
                className="flex items-center justify-center space-x-2"
              >
                <i className="dx-icon dx-icon-arrowleft"></i>
                <span>Back to Sign In</span>
              </Link>
            </div>
          </Item>
        </Form>
      </form>
      <div className="flex items-center justify-between mt-[70px]">
        <p className="m-0 text-xs">
          B’Logic<sup className="ms-[0.5px]">®</sup> <i>i</i>QMS
        </p>
        <p className="m-0 text-xs">All rights reserved - 2025</p>
      </div>
    </>
  );
}

const emailEditorOptions = {
  stylingMode: "outlined",
  placeholder: "Enter your email",
  mode: "email",
  buttons: [
    {
      name: "emailIcon",
      location: "before", // Show icon before the input text
      options: {
        icon: "email", // Default DevExtreme email icon
        stylingMode: "text",
      },
    },
  ],
};
const submitButtonAttributes = { class: "submit-button" };
